import type { IPublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { CustomNavigationClient } from '@ui/auth/navigationClient';
import { EnvBanner } from '@ui/components/EnvBanner';
import { FullScreenLoader } from '@ui/components/FullScreenLoader';
import { AuthProvider } from '@ui/state/auth';
import { GlobalStateProvider } from '@ui/state/global';
import { Suspense, useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { Outlet, useNavigate } from 'react-router';

import { store } from './store';

type AppProps = {
  msalInstance: IPublicClientApplication;
};

export function App({ msalInstance }: AppProps) {
  // configure MSAL redirects between pages to use internal routing
  const navigate = useNavigate();
  const [navigationClient] = useState(
    () => new CustomNavigationClient(navigate),
  );

  useEffect(() => {
    msalInstance.setNavigationClient(navigationClient);
  }, [msalInstance, navigationClient]);

  return (
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <Provider store={store}>
          <GlobalStateProvider>
            <Suspense fallback={<FullScreenLoader />}>
              <EnvBanner />
              <Outlet />
            </Suspense>
          </GlobalStateProvider>
        </Provider>
      </AuthProvider>
    </MsalProvider>
  );
}
